import useRecordThumbnail from '$tablet-app/src/app/images/hooks/useRecordThumbnail';
import { useMainDrawerNavigation } from '$tablet-app/src/app/navigation/hooks';
import { ChatRecipeItem } from '@akin-home/chat';
import { OptionModel, OptionType } from '@akin-home/options';
import { useListOptionsByType } from '@akin-home/options/react';
import { useGetRecipe } from '@akin-home/recipes/react';
import { Text } from '@akin-home/text/native';
import styled from 'styled-components/native';
import { ChatItemDialogBody, ChatItemHeader } from '../../ChatItem';
import { useDismissChatItemDialog } from '../ChatItemDialog';
import { ChatItemDialogProps } from '../ChatItemDialog/ChatItemDialogProps';

export const RecipesChatDialog = (
  props: ChatItemDialogProps<ChatRecipeItem>
) => {
  const {
    chat_item: {
      data: { items },
    },
  } = props;

  const { navigate } = useMainDrawerNavigation();

  const { data: special_diets } = useListOptionsByType({
    type: OptionType.SPECIAL_DIET,
  });

  const onDismiss = useDismissChatItemDialog();

  const onPressNavigate = () => {
    navigate('Meals');
    onDismiss();
  };

  const onPressRecipe = (recipe_id: string) => {
    navigate('RecipeDetails', { recipe_id });
    onDismiss();
  };

  return (
    <>
      <ChatItemHeader
        title="Meals"
        icon="salad"
        onPressOpen={onPressNavigate}
        onDismiss={onDismiss}
      />
      <ChatItemDialogBody>
        {items.map((item) => (
          <RecipeItem
            key={item.item_id}
            id={item.item_id}
            special_diets={special_diets}
            onPress={onPressRecipe}
          />
        ))}
      </ChatItemDialogBody>
    </>
  );
};

const RecipeItem = (props: {
  id: string;
  special_diets?: OptionModel[];
  onPress(id: string): void;
}) => {
  const { data } = useGetRecipe({ id: props.id });

  const { source } = useRecordThumbnail({ record: data });

  const special_diet_text = props.special_diets
    ?.filter((diet) => data?.specialDietIDs?.includes(diet.id))
    ?.map((diet) => diet.label)
    .join(', ');

  const onPress = () => props.onPress(props.id);

  return data ? (
    <Body onPress={onPress}>
      {source ? <Image source={source} /> : null}

      <BodyContent>
        <Text variant="h3" weight="bold" color="white">
          {data.name}
        </Text>
        {special_diet_text ? (
          <Text weight="semibold" color="white">
            {special_diet_text}
          </Text>
        ) : null}
      </BodyContent>
    </Body>
  ) : null;
};

const Body = styled.TouchableOpacity`
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  gap: 20px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom-width: 1px;
  border-bottom-color: grey;
`;

const BodyContent = styled.View`
  flex: 1;
  flex-direction: column;
  gap: 10px;
  min-width: 50%;
`;

const Image = styled.Image`
  aspect-ratio: 1;
  width: 150px;
  border-radius: 10px;
`;
